import Icon from "assets/icons";
import { MessageBarTypes } from "./type";
import classNames from "classnames";

export default function MessageBar(props: MessageBarTypes) {
  return (
    <div className={classNames("messageBar", `messageBar--${props.type}`)}>
      {!props.hideIcon && (
        <div className="messageBar_iconWrapper">
          <Icon.InfoCircle />
        </div>
      )}
      <div className="messageBar_contentWrapper">{props.children}</div>
    </div>
  );
}
